var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLegal = function SvgLegal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Legal_svg__a)",
    fill: "#5C7AFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.153 16.957H7.64a.522.522 0 1 0 0 1.043h9.513a.522.522 0 1 0 0-1.043ZM8.138 14.422a.522.522 0 0 0 .522.522h7.473a.522.522 0 1 0 0-1.044H8.66a.522.522 0 0 0-.522.522ZM10.303 10.714l-.456.702a.522.522 0 1 0 .871.571l.743-1.134 2.419-3.694.743-1.137a.521.521 0 1 0-.871-.572l-.46.7-7.071-4.641.459-.7a.523.523 0 1 0-.874-.573l-.743 1.137-1.21 1.847-1.955 2.984a.522.522 0 0 0 .872.574l.459-.702 3.102 2.03-5.917 8.741a.522.522 0 0 0 .864.584l5.924-8.754 3.101 2.037ZM3.782 5.202l1.847-2.82 7.105 4.639-1.847 2.822-7.105-4.64Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Legal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};

export default SvgLegal;